import Vue from 'vue'
import VueRouter from 'vue-router'

import RestartReq from '../views/RestartReq'

Vue.use(VueRouter)

const routes = [
  {
    path: '/reset-password',
    name: 'Home',
    component: RestartReq
  },
  {
    path: '/new-password/:token',
    name: 'SetPassword',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/SetPassword.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
